import { render } from "./More.vue?vue&type=template&id=0b948360"
import script from "./More.vue?vue&type=script&lang=js"
export * from "./More.vue?vue&type=script&lang=js"

import "./More.vue?vue&type=style&index=0&id=0b948360&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__